import trim from 'lodash/trim';
import toLower from 'lodash/toLower';
// local imports
import { isEmptyString } from './strings';

export function sanitizeRouteParam(value?: string): string | null {
  return !value || isEmptyString(value) ? null : toLower(trim(value));
}
